<template>
  <NiceModal :name="props.name" @close="close" modalClass="nice-modal-full">
    <embed :src="blob" width="100%" height="100%" class="nice-modal-embed" v-if="!loading && blob" />
    <NiceLoading fullDiv v-if="loading" />
  </NiceModal>
</template>

<script setup>
import { defineProps, defineEmits, inject } from "vue";
const nice = inject("nice");
const emit = defineEmits(["close"]);

const props = defineProps({
  name: {
    type: String,
    default: "pdf-viewer",
  },
  title: {
    type: String,
    default: null,
  },
  loading: Boolean,
  blob: String,
});

function close() {
  nice.modal(props.name, false);
  emit("close");
}
</script>

<style lang="scss">
.nice-modal-full {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 95vw !important;
  max-height: 95vh !important;

  .nice-modal-body {
    padding: 0 !important;
    overflow: hidden !important;
  }
}

.nice-modal-embed {
  height: 100%;
  border-radius: var(--border-radius);
}
</style>
